import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-16 pt-8 pb-8 border-t border-slate-700/30">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="text-slate-500 text-sm text-left">
            © {currentYear} Oxford Holdings. All rights reserved.
            <div className="mt-1 text-xs text-slate-600">Proudly managed in Bulgaria</div>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-slate-400">
            <span className="text-slate-600">|</span>
            <span>ЕИК/EIK: 208557195</span>
            <span className="text-slate-600">|</span>
          </div>
          
          <div className="flex space-x-6 text-sm">
            <a 
              href="#/privacy-policy" 
              className="text-slate-400 hover:text-amber-400 transition-colors duration-300 whitespace-nowrap"
            >
              Privacy Policy
            </a>
            <a 
              href="#/cookie-policy" 
              className="text-slate-400 hover:text-amber-400 transition-colors duration-300 whitespace-nowrap"
            >
              Cookie Policy
            </a>
            <a 
              href="#/terms-of-service" 
              className="text-slate-400 hover:text-amber-400 transition-colors duration-300 whitespace-nowrap"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;